import React from "react";
import Alert from "@mui/material/Alert";

const LoginError = ({ userInfo, setIsShowing }) => {
  return (
    <Alert
      severity="error"
      onClose={() => setIsShowing(false)}
      style={{ marginBottom: "3rem", width: "20rem" }}
    >
      {userInfo && !userInfo.isAuth && "Error occured logging in"}
    </Alert>
  );
};

export default LoginError;
